import {useCallback, useEffect, useState} from "react";

export const useCheckBadWords = () => {
	const [badWords, setBadWords] = useState<string[]>([]);

	useEffect(() => {
		import("modules/constants/badWords")
			.then((response) => setBadWords(response.BadWords))
			.catch(console.log);
	}, []);

	return useCallback(
		(name: string) => {
			return name.split(" ").some((text) => badWords.includes(text.toLowerCase()));
		},
		[badWords]
	);
};
